//================================================================
//  Component: AccessDenied component
//  Bespoke to Inventory, DO NOT USE WITH OTHER PORTALS
//================================================================

//  Purpose: This is used in PageComponent when status is access denied for perticular page

//  Properties:
//    - poratal = {A string, portal name : Inventory , Demand Managment, Commercial, ...}
//    - overridePermissionValue = <Optional> {string, hardcode the permissions that users can request. e.g. 'Administrator' }

//  Example:
//    <AccessDeniedInventory
//      portal={'Demand Management'}
//    ></AccessDenied>

//================================================================


//Libraries
import React, { useState, useContext } from 'react';

//Contexts
import { GetUser } from '../../../Library/GlobalContexts';

//Components

//Functions
import WriteDocument from '../../../Library/WriteDocument';

//Images
import UnauthorisedUser from '../../Images/Splash/Error_Unauthorised.svg';


export default function AccessDeniedInventory({
  portal,
  overridePermissionValue,
}) {

  //------------------------------------------------------
  //  useContexts
  //------------------------------------------------------

  const getUser = useContext(GetUser);

  //------------------------------------------------------
  //  useStates
  //------------------------------------------------------

  const [reason, setReason] = useState('');

  const [submitStatus, setSubmitStatus] = useState('idle'); // 'idle', 'submitting', 'success', 'error'

  const [error, setError] = useState('');

  // Read, Download, Create, Modify, Delete & Administrator
  const [permissionLevel, setPermissionLevel] = useState(overridePermissionValue === undefined ? 'Read' : overridePermissionValue);

  //------------------------------------------------------
  //  Functions
  //------------------------------------------------------

  //Returns the style of each component
  function submitRequest() {

    if (!reason.trim()) return;

    // setSubmitStatus('submitting');
    setError('');

    // Generate a unique case ID based on the current timestamp
    const caseid = `inc-${Date.now()}`;

    const support = {
      'caseid': caseid,
      'portal': portal,
      'casetype': 'Permission Request',
      'description': reason,
      'link': window.location.href, // contains the current 'view' e.g. '/inventory?view=vendors'
      'permissionlevel': permissionLevel, // Read, Download, Create, Modify, Delete & Administrator
      'createdby': {
        'email': getUser?.emailaddress,
        'givenname': getUser?.givenname,
        'surname': getUser?.surname
      },
    };

    WriteDocument('support', caseid, support, false).then(() => {

      setPermissionLevel('Read');
      setSubmitStatus('success');
      setReason('');

    }).catch((error) => {

      console.log(error);
      setSubmitStatus('error');
      setError('Something went wrong. Please try again.');

    });

  }

  //------------------------------------------------------
  //  HTML
  //------------------------------------------------------

  return (
    <div className='p-[2% 4%] flex items-center justify-center mt-5 gap-[48px] min-h-[35vh]'>
      <img src={UnauthorisedUser} height={250} width={250} alt='Grumpy-Cat'></img>

      <div className='flex flex-col items-start'>
        <p className='text-[24px] font-medium mb-0'>You’re not authorised to view this page</p>

        {submitStatus === 'success' && (
          <div className="w-full px-3 py-2 mb-2 bg-[#E7F2DA] border-l-4 border-[#8ABB45]">
            <p className="mb-0 text-gray-600">Successfully submitted.</p>
          </div>
        )}


        {submitStatus === 'error' && (
          <div className="w-full px-3 py-2 mb-2 bg-[#FCF4F6] border-l-4 border-[#C4314B]">
            <p className="mb-0 text-gray-600">{error}</p>
          </div>
        )}

        {/* ----------------------- */}
        {/*         Form            */}
        {/* ----------------------- */}

        {/* Select Permission: */}
        <label className='text-[18px] mt-3'> Select Permission: </label>
        <select 
          disabled={overridePermissionValue === undefined ? false : true} 
          className='Input-Field-Select' 
          onChange={(e) => setPermissionLevel(e.target.value)}
          value={permissionLevel}
        >
          <option selected={overridePermissionValue === undefined ? false : true} value='Read'>Read</option>
          <option value='Download'>Download</option>
          <option value='Create'>Create</option>
          <option value='Modify'>Modify</option>
          <option value='Delete'>Delete</option>
          <option selected={overridePermissionValue === undefined ? false : true} value='Administrator'>Administrator</option>
        </select>

        {/* Let us know why you need access: */}
        <p className='text-[18px] mt-3'>Let us know why you need access:</p>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          id="message"
          rows="4"
          className="block p-2.5 w-[40vw] text-sm rounded-lg border"
          placeholder="Enter your reason here...">
        </textarea>

        {/* ----------------------- */}
        {/*    Button Container     */}
        {/* ----------------------- */}

        <div className="w-full flex justify-end mt-2">

          <button
            className='Primary-Button disabled:opacity-50 disabled:cursor-not-allowed'
            onClick={submitRequest}
            disabled={submitStatus === 'submitting' || reason.trim() === ''}
          >
            {submitStatus === 'submitting' ? 'Submitting...' : 'Submit'}

          </button>
        </div>

      </div>

    </div>

  )

}
